import { createCtx } from "@reatom/framework";

export const ctx = createCtx();
